import { Tables } from "database.types";

export const CONDITIONS_PRIORITIES = [
  "Near Mint",
  "Lightly Played",
  "Moderately Played",
  "Heavily Played",
  "Damaged",
  "Sealed",
];

export function sortVariantsByConditions<
  T extends Array<Tables<"variants"> & { condition: Tables<"conditions"> }>,
>(variants: T): T {
  const conditionToRank = new Map<string, number>();

  CONDITIONS_PRIORITIES.forEach((condition, index) => {
    if (!conditionToRank.has(condition)) {
      conditionToRank.set(condition, index);
    }
  });

  return variants
    .map((variant, originalIndex) => ({
      variant,
      rank: conditionToRank.has(variant.condition.id)
        ? (conditionToRank.get(variant.condition.id) as number)
        : Number.POSITIVE_INFINITY,
      originalIndex,
    }))
    .sort((a, b) => {
      if (a.rank !== b.rank) return a.rank - b.rank;
      return a.originalIndex - b.originalIndex;
    })
    .map((entry) => entry.variant) as T;
}
